/*
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-23 16:03:20
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-10-18 15:50:35
 * @FilePath: \standard-v5\src\router\opinionPublish.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const router = [
  {
    path: '/opinion-publish-home',
    name: 'OpinionPublishHome',
    component: () => import('../views/OpinionPublish/OpinionPublishHome.vue')
  },
  {
    path: '/opinion-publish-process',
    name: 'OpinionPublishProcess',
    component: () => import('../views/OpinionPublish/OpinionPublishProcess.vue'),
    redirect: '/opinion-publishProcess/explain',
    children: [
      {
        path: '/opinion-publishProcess/explain',
        name: 'OpinionPublishExplain',
        component: () => import('../views/OpinionPublish/process/Explain.vue')
      },
      {
        path: '/opinion-publishProcess/project',
        name: 'OpinionPublishProject',
        component: () => import('../views/OpinionPublish/process/Project.vue'),
      },
      {
        path: '/opinion-publishProcess/stage',
        name: 'OpinionPublishStage',
        component: () => import('../views/OpinionPublish/process/Stage.vue'),
      },
      {
        path: '/opinion-publishProcess/organ',
        name: 'OpinionPublishOrgan',
        component: () => import('../views/OpinionPublish/process/Organ.vue'),
      },
      {
        path: '/opinion-publishProcess/confirm',
        name: 'OpinionPublishConfirm',
        component: () => import('../views/OpinionPublish/process/Confirm.vue'),
      }
    ]
  },
  {
    path: '/opinion-publish-detail',
    name: 'OpinionPublishDetail',
    component: () => import('../views/OpinionPublish/OpinionPublishDetail.vue'),
  }
]

export default router